module.exports = __webpack_public_path__ + "img/Kunkka.184de4b3.png";